import { render, staticRenderFns } from "./event-detail.vue?vue&type=template&id=73f11a13&"
import script from "./event-detail.vue?vue&type=script&lang=js&"
export * from "./event-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports